// extracted by mini-css-extract-plugin
export default {"backBtn":"BackPage_backBtn__u2MO2","animationRoll":"BackPage_animationRoll__kIPL9"};